import PropTypes from 'prop-types';
import React from 'react';
import css from './ReportAd.scss';
import { injectIntl } from 'react-intl';

export const ReportAd = ({ itemId, onClick, intl }) => {
    const adID = intl.formatMessage({ id: 'adID' });
    const reportAd = intl.formatMessage({ id: 'reportAd' });

    return (
        <div className={ css.reportTextContainer }>
            <strong>{ adID } { itemId }</strong>
            <p className={ css.reportText } onClick={ onClick }>
                { reportAd }
            </p>
        </div>
    );
};

ReportAd.propTypes = {
    itemId: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    intl: PropTypes.shape({
        formatMessage: PropTypes.func.isRequired
    }).isRequired
};

export default injectIntl(ReportAd);
